// extracted by mini-css-extract-plugin
module.exports = {"Head":"News__Head_3jFBz","Title":"News__Title_34YK3","Cards":"News__Cards_2J8ER grid"};